// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2G_Qv","head":"Table_head__-lKky","col":"Table_col__3kyB1"};